import { api } from './client';

export const COMP_TYPE_OPTIONS = [
  { value: 'GENERAL', label: '通用' },
  { value: 'BEAUTY', label: '美业（瑞小美）' },
  { value: 'PET', label: '宠物（杨杨宠物）' },
];

export function compTypeLabel(value?: string | null): string {
  return COMP_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? '通用';
}

export type ImChannel = 'dingtalk' | 'wecom';

export interface TenantListItem {
  id: number;
  name: string;
  slug: string;
  logo: string | null;
  compType: string | null;
  imChannel: ImChannel;
  status: 'ACTIVE' | 'SUSPENDED' | 'ARCHIVED';
  maxEmployees: number | null;
  tokenBalance: string;
  employeeCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface TenantDetail extends TenantListItem {
  batchCount: number;
  adminEmpNos: string | null;
  superAdminEmpNos: string | null;
  dingtalkCorpId: string | null;
  dingtalkAppKey: string | null;
  dingtalkAppSecret: string | null;
  dingtalkAgentId: string | null;
  dingtalkRobotCode: string | null;
  dingtalkPushMode: string;
  dingtalkTestUserIds: string | null;
  wecomCorpId: string | null;
  wecomAgentId: string | null;
  wecomSecret: string | null;
}

export interface PageResult<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}

export const platformApi = {
  login: (username: string, password: string) =>
    api.post<any, { accessToken: string; profile: { adminId: number; username: string; name: string } }>(
      '/platform/auth/login',
      { username, password },
    ),

  me: () => api.get('/platform/auth/me'),

  listTenants: (params?: { search?: string; status?: string; page?: number; size?: number }) =>
    api.get<any, PageResult<TenantListItem>>('/platform/tenants', { params }),

  getTenant: (id: number) =>
    api.get<any, TenantDetail>(`/platform/tenants/${id}`),

  createTenant: (data: { name: string; slug: string; logo?: string; compType?: string; imChannel?: ImChannel }) =>
    api.post('/platform/tenants', data),

  updateTenant: (
    id: number,
    data: { name?: string; logo?: string; maxEmployees?: number; compType?: string; imChannel?: ImChannel },
  ) =>
    api.patch(`/platform/tenants/${id}`, data),

  updateTenantStatus: (id: number, status: string) =>
    api.patch(`/platform/tenants/${id}/status`, { status }),

  updateTenantAdmins: (id: number, data: { adminEmpNos?: string; superAdminEmpNos?: string }) =>
    api.patch(`/platform/tenants/${id}/admins`, data),

  adjustToken: (id: number, amount: number, reason?: string) =>
    api.patch(`/platform/tenants/${id}/token`, { amount, reason }),

  updateTenantDingtalk: (id: number, data: Record<string, string | undefined>) =>
    api.patch(`/platform/tenants/${id}/dingtalk`, data),

  updateTenantWecom: (id: number, data: Record<string, string | undefined>) =>
    api.patch(`/platform/tenants/${id}/wecom`, data),

  testTenantWecom: (id: number) =>
    api.post<any, { ok: boolean; message?: string; expires_in?: number }>(
      `/platform/tenants/${id}/wecom/test`,
    ),

  checkDingtalkHealth: (id: number) =>
    api.get<any, { ok: boolean; message?: string }>(`/platform/tenants/${id}/dingtalk/health`),

  syncTenantIm: (
    id: number,
    data: { apply?: boolean; deptIds?: number[]; userIds?: string[] },
  ) =>
    api.post<any, SyncDingtalkResult>(`/platform/tenants/${id}/im/sync`, data, {
      timeout: 300_000,
    }),

  /** @deprecated 使用 syncTenantIm */
  syncTenantDingtalk: (
    id: number,
    data: { apply?: boolean; deptIds?: number[]; userIds?: string[] },
  ) =>
    api.post<any, SyncDingtalkResult>(`/platform/tenants/${id}/im/sync`, data, {
      timeout: 300_000,
    }),
};

export interface SyncDingtalkResult {
  syncLogId: number;
  added: Array<{ userid: string; name: string }>;
  changed: Array<{ userid: string }>;
  removed: Array<{ userid: string; name: string; employeeId: number }>;
  applied?: { created: number; updated: number; markedLeft: number };
  dryRun: boolean;
  scope: 'ALL' | 'PARTIAL';
}
